import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock, ShieldCheck, CreditCard } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function PricingOffer() {
  return;
}